import React from 'react';
import sanitize from '../../utils/sanitize';

const md = require('markdown-it')({ html: true });

function Markdown({ content }) {
  if (!content) return null;

  return (
    <div dangerouslySetInnerHTML={{ __html: sanitize(md.render(content)) }} />
  );
}
export default Markdown;
